import { render, staticRenderFns } from "./importText.vue?vue&type=template&id=7550b6ca&scoped=true&"
import script from "./importText.vue?vue&type=script&lang=js&"
export * from "./importText.vue?vue&type=script&lang=js&"
import style0 from "./importText.vue?vue&type=style&index=0&id=7550b6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7550b6ca",
  null
  
)

export default component.exports